import ReportTypes from "../types/ReportTypes"

let reports: ReportTypes[] = [
    {
        name: "Census",
        description: "Returns census information for all active employees.",
        properties: {
            items: [
                {
                    title: "Employee Number",
                    key: "EmployeeNumber",
                    order: 1,
                    sort: { isDefault: false, direction: null },
                    isCensusSource: false
                },
                {
                    title: "Name",
                    key: "DisplayName",
                    order: 2,
                    sort: { isDefault: false, direction: null },
                    isCensusSource: false
                },
                {
                    title: "Department",
                    key: "HomeDepartment",
                    order: 2,
                    sort: { isDefault: false, direction: null },
                    isCensusSource: false
                },
                {
                    title: "Location Code",
                    key: "LocationCode",
                    order: 2,
                    sort: { isDefault: false, direction: null },
                    isCensusSource: false
                },
                {
                    title: "Job Title",
                    key: "JobTitle",
                    order: 3,
                    sort: { isDefault: false, direction: null },
                    isCensusSource: false
                },
                {
                    title: "Occupation Type",
                    key: "OccupationTypeDesc",
                    order: 2,
                    sort: { isDefault: false, direction: null },
                    isCensusSource: false
                },
                {
                    title: "Gender",
                    key: "Gender",
                    order: 4,
                    sort: { isDefault: true, direction: "ASC" },
                    isCensusSource: true
                },
                {
                    title: "Ethnicity",
                    key: "Ethnicity",
                    order: 5,
                    sort: { isDefault: false, direction: null },
                    isCensusSource: true
                }
            ],
            filterOn: [
                { key: "Inactive", value: false, alias: "Active employees", aliasValue: null },
            ]
        }
    }

    // ,


    // {
    //     name: "HR 2023 Admins",
    //     description: "Runs a report for all active employees in Admin profit center with A51 Census data.",
    //     properties: {
    //         items: [
    //             {
    //                 title: "Employee Number",
    //                 key: "EmployeeNumber",
    //                 order: 1,
    //                 sort: { isDefault: false, direction: null },
    //                 isCensusSource: false
    //             },
    //             {
    //                 title: "Name",
    //                 key: "DisplayName",
    //                 order: 2,
    //                 sort: { isDefault: false, direction: null },
    //                 isCensusSource: false
    //             },
    //             {
    //                 title: "Department",
    //                 key: "HomeDepartment",
    //                 order: 2,
    //                 sort: { isDefault: false, direction: null },
    //                 isCensusSource: false
    //             },
    //             {
    //                 title: "Location Code",
    //                 key: "LocationCode",
    //                 order: 2,
    //                 sort: { isDefault: false, direction: null },
    //                 isCensusSource: false
    //             },
    //             {
    //                 title: "Job Title",
    //                 key: "JobTitle",
    //                 order: 3,
    //                 sort: { isDefault: false, direction: null },
    //                 isCensusSource: false
    //             },
    //             {
    //                 title: "Occupation Type",
    //                 key: "OccupationTypeDesc",
    //                 order: 2,
    //                 sort: { isDefault: false, direction: null },
    //                 isCensusSource: false
    //             },
    //             {
    //                 title: "Gender",
    //                 key: "Gender",
    //                 order: 4,
    //                 sort: { isDefault: true, direction: "ASC" },
    //                 isCensusSource: true
    //             },
    //             {
    //                 title: "Ethnicity",
    //                 key: "Ethnicity",
    //                 order: 5,
    //                 sort: { isDefault: false, direction: null },
    //                 isCensusSource: true
    //             }
    //         ],
    //         filterOn: [
    //             { key: "HomeProfitCenterId", value: 50, alias: "Home Profit Center", aliasValue: "Admin" },
    //         ]
    //     }
    // }


    // ,


    // {
    //     name: "HR 2023 NO A51",
    //     description: "Runs a report for all active employees without A51 Census data.",
    //     properties: {
    //         items: [
    //             {
    //                 title: "Employee Number",
    //                 key: "EmployeeNumber",
    //                 order: 1,
    //                 sort: { isDefault: false, direction: null },
    //                 isCensusSource: false
    //             },
    //             {
    //                 title: "Name",
    //                 key: "DisplayName",
    //                 order: 2,
    //                 sort: { isDefault: false, direction: null },
    //                 isCensusSource: false
    //             },
    //             {
    //                 title: "Job Title",
    //                 key: "JobTitle",
    //                 order: 3,
    //                 sort: { isDefault: false, direction: null },
    //                 isCensusSource: false
    //             }
    //         ],
    //         filterOn: [
    //             // { key: "HomeProfitCenterId", value: 50, alias: "Home Profit Center", aliasValue: "Admin" },
    //         ]
    //     }
    // }
]

export default reports